import { render, staticRenderFns } from "./InvoiceGenerator.vue?vue&type=template&id=48a3bcec"
import script from "./InvoiceGenerator.vue?vue&type=script&lang=js"
export * from "./InvoiceGenerator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports